import React from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { FiSun, FiMoon } from 'react-icons/fi';
import { useThemeMode } from '../theme/ThemeContext';

const Button = styled.button`
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text);
  cursor: pointer;
  font-size: 1.15rem;
  overflow: hidden;
  transition: border-color 0.25s ease, background 0.25s ease;

  &:hover { border-color: var(--primary-light); background: var(--surface-hover); }
`;

const ThemeToggle = () => {
  const { theme, toggle } = useThemeMode();
  const isDark = theme === 'dark';

  return (
    <Button onClick={toggle} aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}>
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={theme}
          initial={{ y: -18, opacity: 0, rotate: -90 }}
          animate={{ y: 0, opacity: 1, rotate: 0 }}
          exit={{ y: 18, opacity: 0, rotate: 90 }}
          transition={{ duration: 0.25 }}
          style={{ display: 'grid', placeItems: 'center' }}
        >
          {isDark ? <FiMoon /> : <FiSun />}
        </motion.span>
      </AnimatePresence>
    </Button>
  );
};

export default ThemeToggle;
